
import LocationTick from "../../../assets/filled/LocationTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LocationTickIcon({ className, dataTestid = "LocationTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LocationTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
